import routes from './routes.router.js';
import { createRouter, createWebHashHistory } from 'vue-router';
import middlewaresInitializer from './middlewaresInitializer.router';

const router = createRouter({
	routes,
	history: createWebHashHistory(),
	scrollBehavior: () => {
		return { top: 0, behavior: 'smooth' };
	},
});

middlewaresInitializer(router);

export default router;
